import { __extends } from "tslib";
import { ASObject } from './ASObject';
import { assert } from '@awayjs/graphics';
import { release } from '@awayfl/swf-loader';
var ASClass = /** @class */ (function (_super) {
    __extends(ASClass, _super);
    function ASClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ASClass.prototype.axCoerce = function (v) {
        return v;
    };
    Object.defineProperty(ASClass.prototype, "prototype", {
        get: function () {
            release || assert(this.dPrototype);
            return this.dPrototype;
        },
        enumerable: false,
        configurable: true
    });
    ASClass.classInitializer = null;
    return ASClass;
}(ASObject));
export { ASClass };
